import React, { useState } from "react";

import "./explore-layout.scss";

import {ExploreLoading} from "../explore-loading/explore-loading";
import {EmptySearch} from "../empty-search/empty-search";
import {Orders} from "./orders/orders";
import {Products} from "./products/products";
import {Templates} from "./templates/templates";
import {Navigation} from "./navigation/navigation";
import {Blogs} from "./blogs/blogs";
import {Shimmer} from "../common/shimmer/shimmer";

export const ExploreLayout = ({
    apis,
    blogPosts,
    cart,
    categories,
    combinedItems,
    company,
    deleteTargetOrder, setDeleteTargetOrder,
    isApiLoading,
    orders,
    products,
    agentHasYearlySubscription,
    paywallModal,
    agentBenefits,
    templateDownloadModal,
    queryParam,
    routerHistory,
    session,
    userLevels
}) => {

    const visibilityContent = isApiLoading ? 'hidden' : 'visible'

    const hasResults = didReturnSearchResults(combinedItems, products, orders, categories, blogPosts)

    return (
        <div className="explore-dznts925">
            <ExploreLoading {...{isApiLoading}} />
            <div className={`explore-layout ${visibilityContent}`}>
                <Navigation {...{combinedItems}} />
                <Products {...{products}} />
                <Orders {...{apis, cart, company, orders, queryParam, routerHistory, session, deleteTargetOrder, setDeleteTargetOrder}} />
                <Templates {...{queryParam, categories, agentHasYearlySubscription, paywallModal, agentBenefits, templateDownloadModal, userLevels}} />
                <Blogs {...{blogPosts}} />
            </div>
            {
                (!isApiLoading && !hasResults) &&
                <EmptySearch {...{queryParam}} />
            }
        </div>
    )
}

const didReturnSearchResults = (combinedItems, products, orders, categories, blogPosts) => {
    if(Array.isArray(combinedItems) && combinedItems.length > 0) {
        return true
    }

    if(Array.isArray(products) && products.length > 0) {
        return true
    }

    if(Array.isArray(orders) && orders.length > 0) {
        return true
    }

    if(Array.isArray(categories) && categories.length > 0) {
        return true
    }

    if(Array.isArray(blogPosts) && blogPosts.length > 0) {
        return true
    }

    return false
}